import React, { Component } from "react";
import ArrowLeftSVG from "../../Assets/svg/ArrowLeftSVG.svg";
import { withRouterHooks } from "../../withRouters/withRoutersHook";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  FetchAllUsersAction,
  BanAndUnbanUserAction,
  FetcIndividualUserAction,
  FetchAllDepartmentsAction,
  BulkAssignDepartmentstoUsersAction,
  ChangeRoleAction,
  ManualCreateUserAction,
  DeleteUserAction,
} from "../../Actions/AdminUser";
import { GetUserAction } from "../../Actions/Authentication";
import { EllipsisVertical, Users, Search, Building2, UserPlus, MessageSquare, UserRound, Trash2, ChevronLeft } from "lucide-react";
import { extractAxiosError } from "../../utils/errorUtils";
import TableLoader from "../Common/TableLoader";
import DropdownField from "../Dashboard/FileManager/DropdownField";
import Modal from "../Common/Modal";
import Tooltip from "../Common/Tooltip";

const BASE_ROLE_OPTIONS = [
  { value: "user", label: "User" },
  { value: "admin", label: "Admin" },
  { value: "superuser", label: "Superuser" },
];
const PRIME_ROLE_OPTION = { value: "prime_superuser", label: "Prime Superuser" };
const ALL_ROLE_LABELS = {
  user: "User",
  admin: "Admin",
  superuser: "Superuser",
  prime_superuser: "Prime Superuser",
};

const PILL_BASE =
  "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ring-1 ring-inset";

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      showDropDownId: null,
      selectedUsers: [],
      multiAssignActive: false,
      showAssignConfirmation: false,
      selectedDepartment: "",
      departments: [],
      assignmentLoading: false,
      pageInput: "1",
      showActionsMenu: false,
      searchQuery: "",
      statusMessage: null,
      changeRoleUser: null,
      changeRoleValue: "",
      changeRoleLoading: false,
      changeRoleWarning: null,
      changeRoleWarningOverrideable: false,
      showCreateUserModal: false,
      createUserForm: { first_name: "", last_name: "", middle_name: "", email: "", department: "", company_name: "" },
      createUserLoading: false,
      banConfirmUser: null,
      banLoading: false,
      deleteConfirmUser: null,
      deleteLoading: false,
    };
  }

  static propTypes = {
    allUsersData: PropTypes.shape({
      count: PropTypes.number.isRequired,
      next: PropTypes.string,
      previous: PropTypes.string,
      results: PropTypes.arrayOf(PropTypes.object).isRequired,
    }).isRequired,
    allUsersLoading: PropTypes.bool.isRequired,
    loadedAllUsersSuccess: PropTypes.bool.isRequired,
    departmentsData: PropTypes.array,
    FetchAllUsersAction: PropTypes.func.isRequired,
    BanAndUnbanUserAction: PropTypes.func.isRequired,
    FetcIndividualUserAction: PropTypes.func.isRequired,
    FetchAllDepartmentsAction: PropTypes.func.isRequired,
    BulkAssignDepartmentstoUsersAction: PropTypes.func.isRequired,
    ChangeRoleAction: PropTypes.func.isRequired,
    GetUserAction: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
  };

  componentDidMount() {
    this.props.FetchAllUsersAction(this.state.currentPage);
    this.fetchDepartments();
    this.props.GetUserAction();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    if (this._statusTimer) clearTimeout(this._statusTimer);
    if (this._searchTimer) clearTimeout(this._searchTimer);
  }

  handleClickOutside = () => {
    this.setState({ showDropDownId: null, showActionsMenu: false });
  };

  handleSearchChange = (e) => {
    const searchQuery = e.target.value;
    this.setState({ searchQuery, currentPage: 1 });
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      this.props.FetchAllUsersAction(1, searchQuery);
    }, 400);
  };

  componentDidUpdate(prevProps) {
    if (this.props.departmentsData !== prevProps.departmentsData) {
      const source = this.props.departmentsData;
      const depts = Array.isArray(source)
        ? source
        : source?.departments || source?.results || [];
      this.setState({ departments: depts });
    }
  }

  fetchDepartments = async () => {
    try {
      const result = await this.props.FetchAllDepartmentsAction();
      const depts = Array.isArray(result)
        ? result
        : result?.departments || result?.results || [];
      this.setState({ departments: depts });
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  handleDropDown = (userId) => {
    this.setState((prevState) => ({
      showDropDownId: prevState.showDropDownId === userId ? null : userId,
    }));
  };

  handlePreviousPage = () => {
    if (this.state.currentPage > 1) {
      const newPage = this.state.currentPage - 1;
      this.setState({ currentPage: newPage, pageInput: String(newPage) }, () => {
        this.props.FetchAllUsersAction(newPage, this.state.searchQuery);
      });
    }
  };

  handleNextPage = () => {
    const totalPages = Math.ceil(this.props.allUsersData.count / 5);
    if (this.state.currentPage < totalPages) {
      const newPage = this.state.currentPage + 1;
      this.setState({ currentPage: newPage, pageInput: String(newPage) }, () => {
        this.props.FetchAllUsersAction(newPage, this.state.searchQuery);
      });
    }
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber, pageInput: String(pageNumber) }, () => {
      this.props.FetchAllUsersAction(pageNumber, this.state.searchQuery);
    });
  };

  handlePageInputChange = (e) => {
    this.setState({ pageInput: e.target.value });
  };

  handlePageInputSubmit = (e) => {
    const totalPages = Math.ceil((this.props.allUsersData?.count || 0) / 5);
    if (e.key === "Enter") {
      const page = parseInt(this.state.pageInput, 10);
      if (!isNaN(page) && page >= 1 && page <= totalPages) {
        this.handlePageChange(page);
      } else {
        this.setState({ pageInput: String(this.state.currentPage) });
      }
      e.target.blur();
    }
  };

  handlePageInputBlur = () => {
    const totalPages = Math.ceil((this.props.allUsersData?.count || 0) / 5);
    const page = parseInt(this.state.pageInput, 10);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      this.handlePageChange(page);
    } else {
      this.setState({ pageInput: String(this.state.currentPage) });
    }
  };

  handleEditUserServices = (email) => {
    this.props.FetcIndividualUserAction(email).then(() => {
      this.props.navigate(email);
    });
  };

  handleToggle = async () => {
    const { banConfirmUser } = this.state;
    if (!banConfirmUser) return;

    const action = banConfirmUser.is_banned ? "unbanned" : "banned";
    this.setState({ banLoading: true });
    try {
      await this.props.BanAndUnbanUserAction(
        banConfirmUser.email,
        !banConfirmUser.is_banned
      );
      this.props.FetchAllUsersAction(this.state.currentPage);
      this.showStatus(`User ${banConfirmUser.email} has been ${action}.`);
      this.setState({ banConfirmUser: null, banLoading: false });
    } catch (err) {
      this.setState({ banLoading: false });
      this.showStatus(
        extractAxiosError(err, `Failed to ${action.replace("ned", "")} user.`),
        "error"
      );
    }
  };

  handleMultiAssign = () => {
    if (
      this.state.multiAssignActive &&
      this.state.selectedUsers.length > 0 &&
      !this.state.showAssignConfirmation
    ) {
      this.setState({ showAssignConfirmation: true });
      return;
    }
    if (this.state.showAssignConfirmation) {
      this.setState({ showAssignConfirmation: false });
      return;
    }
    this.setState((prevState) => ({
      multiAssignActive: !prevState.multiAssignActive,
      showAssignConfirmation: false,
      selectedUsers: prevState.multiAssignActive ? [] : prevState.selectedUsers,
    }));
  };

  handleDepartmentSelect = (e) => {
    this.setState({ selectedDepartment: e.target.value });
  };

  handleConfirmAssignment = async () => {
    const { selectedUsers, selectedDepartment, departments } = this.state;
    const { allUsersData } = this.props;

    const deptLookup = departments.map((dept) => ({ id: dept.id, name: dept.name }));
    const selectedDeptName =
      deptLookup.find((dept) => dept.id.toString() === selectedDepartment.toString())?.name ||
      selectedDepartment;

    const selectedUserEmails = selectedUsers
      .map((userId) => allUsersData.results.find((u) => u.id === userId)?.email)
      .filter(Boolean);

    if (selectedUserEmails.length === 0) {
      this.showStatus("No valid user emails found for assignment.", "error");
      return;
    }

    this.setState({ assignmentLoading: true });

    try {
      await this.props.BulkAssignDepartmentstoUsersAction({
        department: selectedDeptName,
        emails: selectedUserEmails,
      });
      this.setState({
        assignmentLoading: false,
        multiAssignActive: false,
        showAssignConfirmation: false,
        selectedUsers: [],
        selectedDepartment: "",
      });
      this.showStatus(`${selectedUserEmails.length} user${selectedUserEmails.length !== 1 ? "s" : ""} assigned to ${selectedDeptName}.`);
      this.props.FetchAllUsersAction(this.state.currentPage);
    } catch (error) {
      this.setState({ assignmentLoading: false });
      this.showStatus(extractAxiosError(error, "Failed to assign users to department."), "error");
    }
  };

  toggleUserSelection = (userId) => {
    this.setState((prevState) => {
      const isSelected = prevState.selectedUsers.includes(userId);
      const selectedUsers = isSelected
        ? prevState.selectedUsers.filter((id) => id !== userId)
        : [...prevState.selectedUsers, userId];
      return { selectedUsers, multiAssignActive: selectedUsers.length > 0 };
    });
  };

  clearSelection = () => {
    this.setState({ selectedUsers: [], multiAssignActive: false, showAssignConfirmation: false });
  };

  showStatus = (message, type = "success") => {
    if (this._statusTimer) clearTimeout(this._statusTimer);
    this.setState({ statusMessage: { message, type } });
    this._statusTimer = setTimeout(() => this.setState({ statusMessage: null }), 4000);
  };

  dismissStatus = () => {
    if (this._statusTimer) clearTimeout(this._statusTimer);
    this.setState({ statusMessage: null });
  };

  handleChangeRole = async (force = false) => {
    const { changeRoleUser, changeRoleValue } = this.state;
    if (!changeRoleUser || !changeRoleValue) return;
    this.setState({ changeRoleLoading: true, changeRoleWarning: null, changeRoleWarningOverrideable: false });
    try {
      await this.props.ChangeRoleAction(changeRoleUser.email, changeRoleValue, force);
      this.showStatus(`${changeRoleUser.email} has been updated to ${ALL_ROLE_LABELS[changeRoleValue]}.`);
      this.setState({ changeRoleUser: null, changeRoleValue: "", changeRoleLoading: false, changeRoleWarning: null, changeRoleWarningOverrideable: false });
      this.props.FetchAllUsersAction(this.state.currentPage);
    } catch (err) {
      this.setState({ changeRoleLoading: false });
      const status = err.response?.status;
      const data = err.response?.data;
      if (status === 409 && data?.warning) {
        this.setState({ changeRoleWarning: data.detail, changeRoleWarningOverrideable: true });
      } else if (status === 403 && data?.detail) {
        this.setState({ changeRoleWarning: data.detail, changeRoleWarningOverrideable: false });
      } else {
        this.showStatus(extractAxiosError(err, "Failed to change user role."), "error");
      }
    }
  };

  handleDeleteUser = async () => {
    const { deleteConfirmUser } = this.state;
    if (!deleteConfirmUser) return;
    this.setState({ deleteLoading: true });
    try {
      await this.props.DeleteUserAction(deleteConfirmUser.email);
      this.showStatus(`User ${deleteConfirmUser.email} has been deleted.`);
      this.setState({ deleteConfirmUser: null, deleteLoading: false });
      this.props.FetchAllUsersAction(this.state.currentPage, this.state.searchQuery);
    } catch (err) {
      this.setState({ deleteLoading: false });
      this.showStatus(extractAxiosError(err, "Failed to delete user."), "error");
    }
  };

  handleCreateUser = async () => {
    const { createUserForm } = this.state;
    this.setState({ createUserLoading: true });
    try {
      await this.props.ManualCreateUserAction(createUserForm);
      this.showStatus(`User ${createUserForm.email} created successfully. Credentials sent via email.`);
      this.setState({
        showCreateUserModal: false,
        createUserForm: { first_name: "", last_name: "", middle_name: "", email: "", department: "", company_name: "" },
        createUserLoading: false,
      });
      this.props.FetchAllUsersAction(this.state.currentPage);
    } catch (err) {
      this.setState({ createUserLoading: false });
      this.showStatus(extractAxiosError(err, "Failed to create user."), "error");
    }
  };

  getRoleLabel = (user) => {
    if (user.is_prime_superuser)
      return { label: "Prime Superuser", color: `${PILL_BASE} bg-purple-50 text-purple-700 ring-purple-200/55` };
    if (user.is_app_superuser)
      return { label: "Superuser", color: `${PILL_BASE} bg-blue-50 text-blue-700 ring-blue-200/55` };
    if (user.is_app_admin)
      return { label: "Admin", color: `${PILL_BASE} bg-indigo-50 text-indigo-700 ring-indigo-200/55` };
    return { label: "User", color: `${PILL_BASE} bg-gray-100 text-gray-600 ring-gray-200/60` };
  };

  renderPagination = () => {
    const { currentPage } = this.state;
    const totalPages = Math.ceil((this.props.allUsersData?.count || 0) / 5);

    return (
      <div className="flex justify-between items-center mt-2 pt-4">
        <button
          onClick={this.handlePreviousPage}
          disabled={currentPage === 1}
          className="flex items-center gap-2 px-4 py-2 border border-blue-100 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-sky-50/80 disabled:opacity-40 disabled:cursor-not-allowed transition-colors shadow-sm"
        >
          <img className="w-4 h-4" src={ArrowLeftSVG} alt="Previous" />
          Previous
        </button>

        <div className="flex items-center gap-2 text-sm text-gray-600 font-medium">
          <span>Page</span>
          <input
            type="text"
            value={this.state.pageInput}
            onChange={this.handlePageInputChange}
            onKeyDown={this.handlePageInputSubmit}
            onBlur={this.handlePageInputBlur}
            onFocus={(e) => e.target.select()}
            className="w-12 h-9 text-center border border-blue-100 rounded-xl text-sm font-medium text-gray-900 outline-none focus:border-primary-blue focus:ring-2 focus:ring-primary-blue/15 transition-colors shadow-sm bg-white/90"
          />
          <span>of {totalPages}</span>
        </div>

        <button
          onClick={this.handleNextPage}
          disabled={currentPage === totalPages}
          className="flex items-center gap-2 px-4 py-2 border border-blue-100 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-sky-50/80 disabled:opacity-40 disabled:cursor-not-allowed transition-colors shadow-sm"
        >
          Next
          <img className="rotate-180 w-4 h-4" src={ArrowLeftSVG} alt="Next" />
        </button>
      </div>
    );
  };

  render() {
    const { allUsersData, allUsersLoading, currentUser } = this.props;
    const { departments, assignmentLoading, statusMessage } = this.state;

    // Only pure Django superusers (is_superuser=true, not app prime) can assign Prime Superuser
    const canAssignPrime = currentUser?.is_superuser && !currentUser?.is_prime_superuser;
    const roleOptions = canAssignPrime ? [...BASE_ROLE_OPTIONS, PRIME_ROLE_OPTION] : BASE_ROLE_OPTIONS;

    const rawUsers = allUsersData?.results || [];
    const users = currentUser
      ? [...rawUsers].sort((a, b) => {
          if (a.id === currentUser.id) return -1;
          if (b.id === currentUser.id) return 1;
          return 0;
        })
      : rawUsers;

    const flattenedDepartments = (departments || []).map((dept) => ({
      id: dept.id,
      name: dept.name,
    }));
    const createUserDirty = Object.values(this.state.createUserForm || {}).some(
      (v) => String(v ?? "").trim().length > 0
    );

    return (
      <div className="flex flex-col w-full min-h-0 flex-1 px-4 md:px-8 pt-6 md:pt-8 pb-2">
        {/* Header */}
        <div className="flex flex-wrap md:flex-nowrap items-center gap-3 mb-6">
          <button
            onClick={() => this.props.navigate("/dashboard/settings")}
            className="p-1.5 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
            aria-label="Back"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <h1 className="font-SFPro font-bold text-2xl text-gray-900 whitespace-nowrap">
            Admin & User Management
          </h1>
          <div className="ml-auto flex items-center gap-3">
            {this.state.selectedUsers.length > 0 && (
              <button
                onClick={() => this.setState({ showAssignConfirmation: true })}
                className="px-4 py-2 rounded-lg text-sm font-medium bg-primary-blue text-white hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Assign ({this.state.selectedUsers.length})
              </button>
            )}
            <div className="relative">
              <button
                type="button"
                onClick={() => this.setState((prev) => ({ showActionsMenu: !prev.showActionsMenu }))}
                className="flex items-center gap-2 px-4 py-2 bg-white border border-blue-100 text-gray-700 rounded-xl text-sm font-medium shadow-sm hover:bg-sky-50/80 transition-colors whitespace-nowrap"
              >
                Actions
              </button>
              {this.state.showActionsMenu && (
                <div className="absolute right-0 top-10 z-30 w-48 bg-white border border-blue-100/90 rounded-xl shadow-lg py-1" onMouseDown={(e) => e.stopPropagation()}>
                  <button
                    onClick={() => { this.setState({ showActionsMenu: false, showCreateUserModal: true }); }}
                    className="w-full flex items-center gap-2 text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <UserRound className="w-4 h-4" />
                    Create User
                  </button>
                  <button
                    onClick={() => { this.props.navigate("/admin-dashboard/create-department"); this.setState({ showActionsMenu: false }); }}
                    className="w-full flex items-center gap-2 text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <Building2 className="w-4 h-4" />
                    Department
                  </button>
                  <button
                    onClick={() => { this.props.navigate("/admin-dashboard/upload"); this.setState({ showActionsMenu: false }); }}
                    className="w-full flex items-center gap-2 text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <UserPlus className="w-4 h-4" />
                    Bulk Accounts
                  </button>
                  <button
                    onClick={() => { this.props.navigate("/admin-dashboard/chat-tracker"); this.setState({ showActionsMenu: false }); }}
                    className="w-full flex items-center gap-2 text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <MessageSquare className="w-4 h-4" />
                    Conversations
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search for a user"
            value={this.state.searchQuery}
            onChange={this.handleSearchChange}
            className="w-full h-11 pl-10 pr-4 border border-blue-100 bg-white/90 rounded-xl text-sm outline-none focus:border-primary-blue focus:ring-2 focus:ring-primary-blue/15 transition-colors shadow-sm"
          />
        </div>

        {/* Status Messages */}
        {statusMessage && (
          <div className={`mb-4 px-4 py-3 rounded-lg text-sm border ${statusMessage.type === "error" ? "bg-red-50 border-red-200 text-red-700" : "bg-green-50 border-green-200 text-green-700"}`}>
            {statusMessage.message}
          </div>
        )}

        {/* Table */}
        <div className="flex-1 bg-white border border-blue-100 rounded-xl overflow-visible flex flex-col shadow-sm">
          {/* Title bar */}
          <div
            className="px-6 py-4 border-b border-blue-100 rounded-t-xl"
            style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)" }}
          >
            <p className="font-inter font-semibold text-sm text-gray-700 uppercase tracking-wider">
              Users ({allUsersData?.count ?? 0})
            </p>
          </div>
          {/* Column headers */}
          <div className="grid grid-cols-[0.3fr_1fr_1.2fr_0.8fr_1fr_0.7fr_0.6fr] items-center px-5 gap-4 py-2 border-b border-gray-100 bg-gray-50/50">
            <div>
              <input
                type="checkbox"
                className="h-4 w-4"
                onChange={() => {
                  const allIds = users.map((u) => u.id);
                  const allSelected = allIds.every((id) => this.state.selectedUsers.includes(id));
                  this.setState({
                    selectedUsers: allSelected ? [] : allIds,
                    multiAssignActive: !allSelected,
                  });
                }}
                checked={users.length > 0 && users.every((u) => this.state.selectedUsers.includes(u.id))}
              />
            </div>
            <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Name</div>
            <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Email</div>
            <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Role</div>
            <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Department</div>
            <div className="text-xs font-medium text-gray-400 uppercase tracking-wider">Status</div>
            <div className="text-xs font-medium text-gray-400 uppercase tracking-wider text-center">Actions</div>
          </div>

          {/* Rows */}
          {allUsersLoading ? (
            <TableLoader />
          ) : users.length === 0 ? (
            <div className="flex flex-1 w-full flex-col items-center justify-center gap-6 py-12">
              <div
                className="w-20 h-20 rounded-full flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)" }}
              >
                <Users className="w-10 h-10 text-blue-400" />
              </div>
              <div className="text-center">
                <p className="text-lg font-semibold text-gray-600">No users found</p>
                <p className="text-sm text-gray-400 mt-1">
                  Users will appear here once they are added to the system
                </p>
              </div>
            </div>
          ) : (
            users.map((user) => {
              const role = this.getRoleLabel(user);
              const isCurrentUser = currentUser && user.id === currentUser.id;
              return (
                <div
                  key={user.id}
                  onMouseDown={(e) => e.stopPropagation()}
                  className={`grid grid-cols-[0.3fr_1fr_1.2fr_0.8fr_1fr_0.7fr_0.6fr] py-3.5 px-5 gap-4 border-t border-gray-100 font-inter text-sm text-gray-700 transition-colors items-center ${
                    isCurrentUser
                      ? "bg-sky-50/70 hover:bg-sky-50/90"
                      : "hover:bg-blue-50/40"
                  }`}
                >
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      className="h-4 w-4"
                      onChange={() => this.toggleUserSelection(user.id)}
                      checked={this.state.selectedUsers.includes(user.id)}
                    />
                  </div>
                  <div className="flex items-center gap-2 min-w-0">
                    <span className="text-gray-900 truncate">
                      {`${user.first_name || ""} ${user.last_name || ""}`.trim() || "—"}
                    </span>
                    {isCurrentUser && (
                      <Tooltip text="Your account">
                        <span className="block w-2 h-2 rounded-full bg-primary-blue" />
                      </Tooltip>
                    )}
                  </div>
                  <div className="text-gray-500 truncate">{user.email}</div>
                  <div>
                    <span className={role.color}>{role.label}</span>
                  </div>
                  <div>
                    {user.active_departments?.length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {user.active_departments.map((dept, idx) => (
                          <span
                            key={idx}
                            className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200/50 whitespace-nowrap"
                          >
                            {dept}
                          </span>
                        ))}
                      </div>
                    ) : user.department ? (
                      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 ring-1 ring-inset ring-gray-200/60 whitespace-nowrap">
                        {user.department}
                      </span>
                    ) : (
                      <span className="text-gray-400 text-xs">Not assigned</span>
                    )}
                  </div>
                  <div>
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ring-1 ring-inset ${
                        user.is_banned
                          ? "bg-red-50 text-red-700 ring-red-200/50"
                          : "bg-green-50 text-green-700 ring-green-200/50"
                      }`}
                    >
                      {user.is_banned ? "Banned" : "Active"}
                    </span>
                  </div>
                  <div className="relative flex items-center justify-center">
                    <button
                      type="button"
                      onClick={() => this.handleDropDown(user.id)}
                      className="p-1.5 rounded-lg text-gray-500 hover:bg-sky-50/90 transition-colors"
                    >
                      <EllipsisVertical className="w-4 h-4" />
                    </button>
                    {this.state.showDropDownId === user.id && (
                      <div className="absolute right-0 top-8 z-20 w-40 bg-white border border-blue-100/90 rounded-xl shadow-lg py-1" onMouseDown={(e) => e.stopPropagation()}>
                        <button
                          onClick={() => this.handleEditUserServices(user.email)}
                          className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => {
                            this.setState({ changeRoleUser: user, changeRoleValue: "", showDropDownId: null });
                          }}
                          className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                        >
                          Change Role
                        </button>
                        <button
                          onClick={() => {
                            this.setState({ banConfirmUser: user, showDropDownId: null });
                          }}
                          className="w-full flex items-center justify-between px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                        >
                          <span>{user.is_banned ? "Unban" : "Ban"}</span>
                          <span className={`text-xs font-medium px-1.5 py-0.5 rounded-full ring-1 ring-inset ${user.is_banned ? "bg-red-50 text-red-600 ring-red-200/45" : "bg-green-50 text-green-600 ring-green-200/45"}`}>
                            {user.is_banned ? "Banned" : "Active"}
                          </span>
                        </button>
                        <div className="h-px bg-gray-100 mx-2 my-1" />
                        <button
                          onClick={() => { this.setState({ deleteConfirmUser: user, showDropDownId: null }); }}
                          className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50"
                        >
                          <Trash2 className="w-4 h-4" />
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Pagination */}
        <div className="mt-auto pt-4 pb-6">
          {this.renderPagination()}
        </div>


        {/* Assign Department Modal */}
        {this.state.showAssignConfirmation && (
          <Modal
            title="Assign Department"
            onClose={() => this.clearSelection()}
            minHeight="420px"
          >
            <p className="text-sm text-gray-500 -mt-2">
              Assign {this.state.selectedUsers.length} selected user{this.state.selectedUsers.length !== 1 ? "s" : ""} to a department.
            </p>
            <DropdownField
              name="selectedDepartment"
              value={this.state.selectedDepartment}
              onChange={this.handleDepartmentSelect}
              placeholder="Select department"
              disabled={assignmentLoading}
              options={flattenedDepartments.map((dept) => ({
                value: dept.id,
                label: dept.name,
              }))}
            />
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => this.clearSelection()}
                disabled={assignmentLoading}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={this.handleConfirmAssignment}
                disabled={!this.state.selectedDepartment || assignmentLoading}
                className="px-4 py-2 rounded-lg text-sm font-medium bg-primary-blue text-white hover:bg-blue-700 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
              >
                {assignmentLoading && (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                )}
                {assignmentLoading ? "Assigning..." : "Confirm"}
              </button>
            </div>
          </Modal>
        )}
        {/* Ban / Unban Confirm Modal */}
        {this.state.banConfirmUser && (
          <Modal
            title={this.state.banConfirmUser.is_banned ? "Unban User" : "Ban User"}
            onClose={() => this.setState({ banConfirmUser: null })}
          >
            <p className="text-sm text-gray-600 -mt-2">
              {this.state.banConfirmUser.is_banned ? (
                <>
                  Are you sure you want to restore access for{" "}
                  <span className="font-semibold text-gray-800">
                    {this.state.banConfirmUser.email}
                  </span>
                  ?
                </>
              ) : (
                <>
                  Are you sure you want to ban{" "}
                  <span className="font-semibold text-gray-800">
                    {this.state.banConfirmUser.email}
                  </span>
                  ? They will lose access until unbanned.
                </>
              )}
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => this.setState({ banConfirmUser: null })}
                disabled={this.state.banLoading}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={this.handleToggle}
                disabled={this.state.banLoading}
                className={`px-4 py-2 rounded-lg text-sm font-medium text-white disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors flex items-center gap-2 ${
                  this.state.banConfirmUser.is_banned
                    ? "bg-primary-blue hover:bg-blue-700"
                    : "bg-red-600 hover:bg-red-700"
                }`}
              >
                {this.state.banLoading && (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                )}
                {this.state.banLoading
                  ? this.state.banConfirmUser.is_banned
                    ? "Unbanning..."
                    : "Banning..."
                  : this.state.banConfirmUser.is_banned
                    ? "Unban"
                    : "Ban"}
              </button>
            </div>
          </Modal>
        )}
        {/* Delete User Confirm Modal */}
        {this.state.deleteConfirmUser && (
          <Modal
            title="Delete User"
            onClose={() => this.setState({ deleteConfirmUser: null })}
          >
            <p className="text-sm text-gray-600 -mt-2">
              Are you sure you want to permanently delete <span className="font-semibold text-gray-800">{this.state.deleteConfirmUser.email}</span>? This action cannot be undone.
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => this.setState({ deleteConfirmUser: null })}
                disabled={this.state.deleteLoading}
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={this.handleDeleteUser}
                disabled={this.state.deleteLoading}
                className="px-4 py-2 rounded-lg text-sm font-medium bg-red-600 text-white hover:bg-red-700 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors flex items-center gap-2"
              >
                {this.state.deleteLoading && (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                )}
                {this.state.deleteLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </Modal>
        )}
        {/* Create User Modal */}
        {this.state.showCreateUserModal && (
          <Modal
            onClose={() => this.setState({ showCreateUserModal: false, createUserForm: { first_name: "", last_name: "", middle_name: "", email: "", department: "", company_name: "" } })}
          >
            <div className="w-full max-w-[560px] mx-auto flex flex-col gap-6">
              {/* Header — left-aligned (matches PDF modal title block) */}
              <div className="flex w-full flex-col items-start text-left">
                <h2 className="font-SFPro font-bold text-xl text-gray-900 w-full text-left">
                  Create New User
                </h2>
                <p className="font-inter text-sm text-gray-400 mt-1 w-full text-left">
                  A password will be auto-generated and emailed to the user.
                </p>
              </div>

              {/* Personal Info */}
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Personal Info</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="font-inter font-medium text-sm text-gray-700">First Name <span className="text-red-400">*</span></label>
                  <input
                    type="text"
                    value={this.state.createUserForm.first_name}
                    onChange={(e) => this.setState((prev) => ({ createUserForm: { ...prev.createUserForm, first_name: e.target.value } }))}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:bg-white focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-all"
                    placeholder="John"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-inter font-medium text-sm text-gray-700">Last Name <span className="text-red-400">*</span></label>
                  <input
                    type="text"
                    value={this.state.createUserForm.last_name}
                    onChange={(e) => this.setState((prev) => ({ createUserForm: { ...prev.createUserForm, last_name: e.target.value } }))}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:bg-white focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-all"
                    placeholder="Doe"
                  />
                </div>
                <div className="col-span-2 flex flex-col gap-1">
                  <label className="font-inter font-medium text-sm text-gray-700">Middle Name <span className="text-gray-300">— optional</span></label>
                  <input
                    type="text"
                    value={this.state.createUserForm.middle_name}
                    onChange={(e) => this.setState((prev) => ({ createUserForm: { ...prev.createUserForm, middle_name: e.target.value } }))}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:bg-white focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-all"
                    placeholder="e.g. James"
                  />
                </div>
              </div>
              </div>

              {/* Contact & Work */}
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Contact & Work</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2 flex flex-col gap-1">
                  <label className="font-inter font-medium text-sm text-gray-700">Email <span className="text-red-400">*</span></label>
                  <input
                    type="email"
                    value={this.state.createUserForm.email}
                    onChange={(e) => this.setState((prev) => ({ createUserForm: { ...prev.createUserForm, email: e.target.value } }))}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:bg-white focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-all"
                    placeholder="john.doe@company.com"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-inter font-medium text-sm text-gray-700">Department <span className="text-gray-300">— optional</span></label>
                  <DropdownField
                    name="createUserDepartment"
                    value={this.state.createUserForm.department}
                    onChange={(e) => this.setState((prev) => ({ createUserForm: { ...prev.createUserForm, department: e.target.value } }))}
                    placeholder="Select department"
                    options={flattenedDepartments.map((dept) => ({ value: dept.name, label: dept.name }))}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="font-inter font-medium text-sm text-gray-700">Company <span className="text-gray-300">— optional</span></label>
                  <input
                    type="text"
                    value={this.state.createUserForm.company_name}
                    onChange={(e) => this.setState((prev) => ({ createUserForm: { ...prev.createUserForm, company_name: e.target.value } }))}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm bg-gray-50 focus:bg-white focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue transition-all"
                    placeholder="e.g. Acme Corp"
                  />
                </div>
              </div>
              </div>

              {/* Actions */}
              <div className="flex w-full gap-3 pt-4 mt-1 border-t border-gray-100">
                <button
                  onClick={() => this.setState({ showCreateUserModal: false, createUserForm: { first_name: "", last_name: "", middle_name: "", email: "", department: "", company_name: "" } })}
                  disabled={this.state.createUserLoading}
                  className="flex-1 h-11 px-4 rounded-lg text-sm font-medium flex items-center justify-center bg-gradient-to-r from-red-500 to-rose-500 text-white hover:from-red-600 hover:to-rose-600 transition-all duration-150 font-inter shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
                <button
                  onClick={this.handleCreateUser}
                  disabled={!this.state.createUserForm.first_name || !this.state.createUserForm.last_name || !this.state.createUserForm.email || this.state.createUserLoading}
                  className={`flex-1 h-11 px-4 rounded-lg text-sm font-medium transition-all duration-150 flex items-center justify-center gap-2 disabled:cursor-not-allowed disabled:opacity-60 disabled:text-white font-inter shadow-sm ${
                    createUserDirty
                      ? "bg-gradient-to-r from-primary-blue to-blue-400 text-white hover:from-blue-600 hover:to-blue-500"
                      : "bg-gradient-to-r from-primary-blue to-blue-400 text-white hover:from-blue-600 hover:to-blue-500"
                  }`}
                >
                  {this.state.createUserLoading && (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  )}
                  {this.state.createUserLoading ? "Creating..." : "Create User"}
                </button>
              </div>
            </div>
          </Modal>
        )}
        {/* Change Role Modal */}
        {this.state.changeRoleUser && (
          <Modal
            onClose={() => this.setState({ changeRoleUser: null, changeRoleValue: "", changeRoleWarning: null, changeRoleWarningOverrideable: false })}
          >
            <div className="w-full max-w-[560px] mx-auto flex flex-col gap-6">
              <div className="flex flex-col items-start text-left">
                <p className="font-inter text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">
                  User Access
                </p>
                <h2 className="mt-2 font-SFPro font-bold text-xl text-gray-900">
                  Change Role
                </h2>
                <p className="mt-2 font-inter text-sm text-gray-500 leading-relaxed">
                  Update access permissions for{" "}
                  <span className="font-semibold text-gray-800">
                    {this.state.changeRoleUser.email}
                  </span>.
                </p>
              </div>

              <div className="rounded-2xl border border-blue-100 bg-gradient-to-br from-white to-blue-50/60 p-4">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="font-inter text-xs font-medium uppercase tracking-wider text-gray-400">
                      Current Role
                    </p>
                    <p className="mt-1 font-inter text-sm text-gray-600">
                      Choose a new access level below.
                    </p>
                  </div>
                  <span className={this.getRoleLabel(this.state.changeRoleUser).color}>
                    {this.getRoleLabel(this.state.changeRoleUser).label}
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-inter text-xs font-medium uppercase tracking-wider text-gray-500">
                  New Role
                </label>
                <DropdownField
                  name="changeRoleValue"
                  value={this.state.changeRoleValue}
                  onChange={(e) => this.setState({ changeRoleValue: e.target.value, changeRoleWarning: null, changeRoleWarningOverrideable: false })}
                  placeholder="Select role"
                  disabled={this.state.changeRoleLoading}
                  options={roleOptions}
                />
              </div>
            {this.state.changeRoleWarning && (
              <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
                <div className="flex-1">
                  <p className="font-medium mb-0.5">Warning</p>
                  <p className="text-amber-700">{this.state.changeRoleWarning}</p>
                </div>
              </div>
            )}
            <div className="flex flex-col-reverse sm:flex-row gap-3 justify-end pt-2">
              <button
                onClick={() => this.setState({ changeRoleUser: null, changeRoleValue: "", changeRoleWarning: null, changeRoleWarningOverrideable: false })}
                disabled={this.state.changeRoleLoading}
                className="w-full sm:w-auto px-4 py-2.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
              >
                Cancel
              </button>
              {this.state.changeRoleWarning && this.state.changeRoleWarningOverrideable ? (
                <button
                  onClick={() => this.handleChangeRole(true)}
                  disabled={this.state.changeRoleLoading}
                  className="w-full sm:w-auto px-4 py-2.5 rounded-lg text-sm font-medium bg-amber-500 text-white hover:bg-amber-600 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
                >
                  {this.state.changeRoleLoading && (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  )}
                  {this.state.changeRoleLoading ? "Saving..." : "Yes, demote anyway"}
                </button>
              ) : (
                <button
                  onClick={() => this.handleChangeRole(false)}
                  disabled={!this.state.changeRoleValue || this.state.changeRoleLoading}
                  className="w-full sm:w-auto px-4 py-2.5 rounded-lg text-sm font-medium bg-gradient-to-r from-primary-blue to-blue-400 text-white hover:from-blue-600 hover:to-blue-500 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2 shadow-sm"
                >
                  {this.state.changeRoleLoading && (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  )}
                  {this.state.changeRoleLoading ? "Saving..." : "Confirm"}
                </button>
              )}
            </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  allUsersData: state.adminUser.allUsersData,
  allUsersLoading: state.adminUser.allUsersLoading,
  loadedAllUsersSuccess: state.adminUser.loadedAllUsersSuccess,
  departmentsData: state.adminUser.departments,
  currentUser: state.authentication.user,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    FetchAllUsersAction,
    BanAndUnbanUserAction,
    FetcIndividualUserAction,
    FetchAllDepartmentsAction,
    BulkAssignDepartmentstoUsersAction,
    ChangeRoleAction,
    ManualCreateUserAction,
    DeleteUserAction,
    GetUserAction,
  })(AdminDashboard)
);
